import { ApiPaths } from "../../../api/ApiPaths";
import { ApiRequest } from "../../../api/ApiRequest";

export type GetAdminOperationLogListSuccessResponseType = {
    logList: {
        userId: string,
        operationTarget: string,
        operationType: string,
        operationContentBefore: string,
        operationContentAfter: string,
        operationTime: string
    }[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getAdminOperationLogList(): Promise<GetAdminOperationLogListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.admin.adminOperationLogList,
        {},
        () => {},
        () => {}
    );
}